var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyPageButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 50,
    height: 50,
    rx: 5,
    fill: "#F9FAFC",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 39C14.25 39 12 39 12 36.75C12 34.5 14.25 27.75 25.5 27.75C36.75 27.75 39 34.5 39 36.75C39 39 36.75 39 36.75 39H14.25ZM25.5 25.5C27.2902 25.5 29.0071 24.7888 30.273 23.523C31.5388 22.2571 32.25 20.5402 32.25 18.75C32.25 16.9598 31.5388 15.2429 30.273 13.977C29.0071 12.7112 27.2902 12 25.5 12C23.7098 12 21.9929 12.7112 20.727 13.977C19.4612 15.2429 18.75 16.9598 18.75 18.75C18.75 20.5402 19.4612 22.2571 20.727 23.523C21.9929 24.7888 23.7098 25.5 25.5 25.5Z",
    fill: "#9E1F15"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPageButton);
export default __webpack_public_path__ + "static/media/MyPageButton.c72be1383cfa118d370e32c9f2aa3b3c.svg";
export { ForwardRef as ReactComponent };